import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { Toaster } from "@/components/ui/toaster";
import { ProcessLoader } from "@/components/shared/process-loader";
import { DeletePopup } from "@/components/shared/delete-popup";
import { ErrorBoundary } from "react-error-boundary";
import { AlertPopup } from "@/components/shared/alert-popup";
import ErrorFallback from "@/components/shared/error-fallback";
import { useApp } from "./use-app";

const App = () => {
  useApp();

  return (
    <div className="h-screen font-poppins">
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => (
          <ErrorFallback
            error={error}
            errorInfo={error.stack || ""}
            resetErrorBoundary={resetErrorBoundary}
          />
        )}
      >
        <RouterProvider router={router} />
        <Toaster />
        <ProcessLoader />
        <DeletePopup />
        <AlertPopup />
      </ErrorBoundary>
    </div>
  );
};

export default App;
